
export const MEDIA_FIELDS = [
    { key: 'name', label: "name",  },
    { key: 'phoneNumber', label: "phone Number" },
    { key: 'email', label: "email", type: "email",  },
    { key: '_function', label: "function", },
    { key: 'gender', label: "gender", type: "fixed-select", options: [{label: "Male", value: "male"}, {label: "Female", value: "female"}]},

]





const FIELDS = [
    ...MEDIA_FIELDS,
]

export default FIELDS


